import React from "react";
import styles from "./ConnectAccountsCta.module.scss";

interface Props {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    children: React.ReactNode;
}

export const ConnectAccountsCta: React.FC<Props> = ({
    title,
    subtitle,
    children,
}) => (
    <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        <div className={styles.actions}>{children}</div>
    </div>
);
